// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1KTe2","file":"styles_file__12-3x"};